import React, { useMemo, useState } from "react";
import { Panel, PanelBody, Button, toast, Icon } from "@optimed/react";
import { useDataLoader, LoadingRegion, formatDate } from "@optimed/react";
import { docplannerService, syncService } from "../api";
import { syncDialog } from "./SyncDialog";

export function FacilityPanel() {
  const [facility, facilitiesPromise] = useDataLoader(() => docplannerService.facilities().then(x => x[0]));
  const [configuration, configurationPromise] = useDataLoader(() => docplannerService.configuration());
  const promise = useMemo(
    () => Promise.all([facilitiesPromise, configurationPromise]),
    [facilitiesPromise, configurationPromise]
  );
  const [syncDisabled, setSyncDisabled] = useState(false);

  function sync() {
    toast.add({
      title: "Synchornizacja danych",
      body: "Rozpoczęto proces synchronizacji",
      autoClose: 5000,
    });
    setSyncDisabled(true);

    syncService.everything().then(
      res => {
        syncDialog.open({ asyncTask: res }).then(() => {
          reload();
        });
      },
      () => {
        toast.error(
          "Synchronizacja danych",
          "Wystąpił błąd rozpoczynania synchornizacji danych, sprawdź logi usługi integracyjnej."
        );
        setSyncDisabled(false);
      }
    );
  }

  function clearCache() {
    syncService.clearCache().then(reload);
  }

  function reload() {
    window.location.reload();
  }

  return (
    <Panel className="mb-3">
      <PanelBody>
        <LoadingRegion promise={promise}>
          <h3>
            <Icon icon="hospital" /> {facility?.name}
          </h3>
          <div className="small">Identyfikator klienta: #{facility?.id}</div>
          <div className="small">
            Zakres synchronizacji: {formatDate(configuration?.currentDate, "yyyy-MM-dd")} -{" "}
            {formatDate(configuration?.maxActiveDate, "yyyy-MM-dd")}
          </div>
          <div className="text-end">
            <div>
              <Button text="Wymuś synchronizację" onClick={sync} disabled={syncDisabled} />
              <Button text="Wyczyść cache" onClick={clearCache} />
            </div>
          </div>
        </LoadingRegion>
      </PanelBody>
    </Panel>
  );
}
